import Vue from 'vue';
import VueApollo from 'vue-apollo';
import parseBoolean from '~/javascripts/lib/parse_boolean';
import NewEESubscriptionApp from '~/javascripts/subscription/components/new_ee_subscription.vue';
import { apolloClient } from '~/javascripts/lib/graphql';

Vue.use(VueApollo);

const initNewEESubscriptionApp = () => {
  const containerElement = document.querySelector('#js-subscription-new');
  if (!containerElement) {
    return false;
  }

  const apolloProvider = new VueApollo({ defaultClient: apolloClient });

  const {
    seatPrice: seatPriceRaw,
    planId,
    planName,
    planCode,
    zuoraAccountNumber,
    promoCode,
  } = containerElement.dataset;

  const eligibleToUsePromoCode = parseBoolean(containerElement.dataset.eligibleToUsePromoCode);
  const showPromotionalOfferText = parseBoolean(containerElement.dataset.showPromotionalOfferText);

  const seatPrice = Number(seatPriceRaw);

  const cloudLicenseEnabled = parseBoolean(containerElement.dataset.cloudLicenseEnabled);

  const customerBillingAccountsPresent = parseBoolean(
    containerElement.dataset.customerBillingAccountsPresent,
  );

  return new Vue({
    el: containerElement,
    provide: {
      planCode,
      eligibleToUsePromoCode,
      showPromotionalOfferText,
      customerBillingAccountsPresent,
      zuoraAccountNumber,
      promoCode,
    },
    apolloProvider,
    render(createElement) {
      return createElement(NewEESubscriptionApp, {
        props: {
          seatPrice,
          planId,
          planName,
          cloudLicenseEnabled,
        },
      });
    },
  });
};

export default initNewEESubscriptionApp;
